import React, { ReactElement } from 'react'
import {
  HeadingText,
  Container,
  Row,
  Col,
  BodyText,
  Link,
  CaptionText,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import * as styles from './intro.css'
import { getImageSrcSet } from './IntroHelpers'
import { PAYPAL_OBJECTS_DIRECTORY } from '../../constants'
import { ImageConfiguration } from '../../../../typings'

type IntroPage = {
  id: string
  images: ImageConfiguration
  title: string
  firstIcon: ReactElement
  firstSubtitle: string
  secondIcon: ReactElement
  secondSubtitle: string
  showPrivacyLink?: boolean
}
type Props = {
  item: IntroPage
  goToPrivacyScreen: () => void
  isSmallerScreen: boolean
  children?: React.ReactNode
}
export function ContainerGeneration(props: Props) {
  const { item, goToPrivacyScreen, isSmallerScreen, children } = props
  const BulletText = isSmallerScreen ? CaptionText : BodyText

  return (
    <Container fluid className={styles.container} form={true}>
      <Row row={{ alignContent: 'center' }} noGutters={true}>
        <Col className={styles.mainImageContainer}>
          <picture>
            <img
              className={styles.carouselImage}
              srcSet={getImageSrcSet(PAYPAL_OBJECTS_DIRECTORY, item.images)}
              alt=""
              aria-hidden="true"
            />
          </picture>
        </Col>
      </Row>
      <Row noGutters={true}>
        <Col>
          <HeadingText
            as="h1"
            size="sm"
            type="strong"
            className={styles.heading}
          >
            <Message id={item.title} />
          </HeadingText>
        </Col>
      </Row>
      <Row noGutters={true}>
        <Col xs={2}>
          <div className={styles.introIcons}>{item.firstIcon}</div>
        </Col>
        <Col xs={10}>
          <BulletText as="p" className={styles.introText}>
            <Message id={item.firstSubtitle} />
          </BulletText>
        </Col>
      </Row>
      <Row noGutters={true}>
        <Col xs={2}>
          <div className={styles.introIcons}>{item.secondIcon}</div>
        </Col>
        <Col xs={10}>
          <BulletText as="p" className={styles.introText}>
            <Message id={item.secondSubtitle} />
            {item.showPrivacyLink && (
              <>
                {' '}
                <Link data-testid="learnMoreButton" onClick={goToPrivacyScreen}>
                  <Message id="create.intro.learnMoreButton" />
                </Link>
              </>
            )}
          </BulletText>
        </Col>
      </Row>
      {children}
    </Container>
  )
}
